const MASKS = {
  a: "a",
  b: "b",
  c: "c",
};

export default function DashCardPhoto({ src, alt, mask = "a" }) {
  const variant = MASKS[mask] || "a";
  return (
    <figure className={`dash-photo dash-photo--${variant}`}>
      <img src={src} alt={alt} width="800" height="450" />
    </figure>
  );
}
